import React from 'react';
import { Box, Heading, Text, useColorModeValue } from '@chakra-ui/react';
import { getFormaCerchioOption } from '../../constants/formeCerchio';
import { FORME_CERCHIO_ICONS } from '../../assets/forme-cerchio/icons';

/**
 * @param {{ value?: string | null }} props
 */
function FormaCerchioDisplay({ value }) {
  const forma = getFormaCerchioOption(value);
  if (!forma) return null;

  const Icon = FORME_CERCHIO_ICONS[forma.icon];
  const cardBg = useColorModeValue('white', 'gray.800');
  const captionColor = useColorModeValue('gray.600', 'gray.400');
  const borderColor = useColorModeValue('rgba(59,35,90,.15)', 'whiteAlpha.300');

  return (
    <Box as="section" mb={8}>
      <Heading size="md" mb={4}>
        Forma del cerchio
      </Heading>
      <Box
        maxW="280px"
        p={4}
        borderRadius="md"
        border="1px solid"
        borderColor={borderColor}
        bg={cardBg}
        textAlign="center"
      >
        {Icon ? (
          <Box
            as={Icon}
            boxSize="56px"
            mx="auto"
            mb={3}
            display="block"
            color="gray.700"
            _dark={{ color: 'gray.200' }}
            aria-hidden
          />
        ) : null}
        <Text fontWeight="semibold" fontSize="md">
          {forma.label}
        </Text>
        <Text fontSize="sm" color={captionColor} mt={2} lineHeight="short">
          {forma.caption}
        </Text>
      </Box>
    </Box>
  );
}

export default FormaCerchioDisplay;
